<template lang="pug">
el-form-item(:label="label")
  .preview-image-container.animated-stripes-bg(
    v-if="previewImageStyle && previewImageStyle.backgroundImage")
      .image(:style="previewImageStyle")
      .drop-shadow
      el-button.remove-button(type="danger" @click="removeImage") Remove
  form.dropzone(v-show="!previewImageStyle || !previewImageStyle.backgroundImage")
    div.dropzone-message(style="display: none")
      span.dropzone-title Drop your file to upload
      span.dropzone-info You can not upload multiple files at once
</template>

<script>
import $http from '@/services/HttpService';
import Dropzone from 'dropzone';
import '../../node_modules/dropzone/dist/dropzone.css';

Dropzone.autoDiscover = false;

export default {
  props: {
    label: { default: '', type: String },
    uploadURL: { default: '', type: String },
    value: { default: '', type: String },
  },
  data() {
    return {};
  },
  computed: {
    previewImageStyle() {
      return {
        backgroundImage: this.value ? `url('${this.value}')` : '',
      };
    },
  },
  mounted() {
    const vm = this;
    const options = {
      // The URL will be changed for each new file being processing
      url: '/',
      // Since we're going to do a `PUT` upload to S3 directly
      method: 'put',
      // Hijack the xhr.send since Dropzone always upload file by using formData
      // ref: https://github.com/danialfarid/ng-file-upload/issues/743
      sending(file, xhr) {
        /* eslint-disable no-underscore-dangle */
        const _send = xhr.send;
        /* eslint-enable no-underscore-dangle */
        /* eslint-disable no-param-reassign */
        xhr.send = () => {
          _send.call(xhr, file);
        };
        /* eslint-enable no-param-reassign */
      },
      // Upload one file at a time since we're using the S3 pre-signed URL scenario
      parallelUploads: 1,
      uploadMultiple: false,

      maxFiles: 1,
      acceptedFiles: 'image/*',

      // Content-Type should be included, otherwise you'll get a signature
      // mismatch error from S3. We're going to update this for each file.
      header: '',
      dictDefaultMessage: document.querySelector('.dropzone-message').innerHTML,
      // We're going to process each file manually (see `accept` below)
      autoProcessQueue: false,
      // Here we request a signed upload URL when a file being accepted
      accept(file, done) {
        $http
          .get(vm.uploadURL, {
            params: {
              filePath: file.name,
              contentType: file.type,
            },
          })
          .then(({ data }) => {
            /* eslint-disable no-param-reassign */
            file.uploadURL = data.url;
            /* eslint-enable no-param-reassign */
            done();
            setTimeout(() => vm.dropzone.processFile(file));
          })
          .catch(error => {
            vm.$emit('error', error);
            vm.$message.error(error);
            setTimeout(() => {
              vm.dropzone.removeAllFiles();
            }, 2000);
            done(error, error);
          });
      },
    };

    this.dropzone = new Dropzone(this.$el.querySelector('form'), options);

    vm.dropzone.on('processing', file => {
      vm.dropzone.options.url = file.uploadURL;
    });

    vm.dropzone.on('success', file => {
      vm.previewImageStyle.backgroundImage = `url('${file.dataURL}')`;
      vm.$emit('input', file.uploadURL.split('?')[0]);
      vm.dropzone.removeFile(file);
    });

    vm.dropzone.on('error', (file, errorMessage) => {
      vm.$emit('error', file);
      vm.$message.error(errorMessage);
      setTimeout(() => {
        vm.dropzone.removeFile(file);
      }, 2000);
    });
  },
  methods: {
    removeImage() {
      this.previewImageStyle.backgroundImage = '';
      this.$emit('input', null);
    },
  },
};
</script>

<style lang="stylus">
primaryBlue = #3498db

.preview-image-container
  position relative
  padding-top 20%

  .image
    position absolute
    top 0
    left 0
    right 0
    bottom 0
    background-size cover
    background-position center

  .drop-shadow
    position absolute
    left 0
    top 0
    right 0
    bottom 0
    background rgba(0, 0, 0, .5)
    opacity 0
    transition all ease-in-out .5s

  .remove-button
    position absolute
    left 50%
    top 50%
    transform translate(-50%, -50%)
    transition all ease-in-out .5s
    opacity 0

  &:hover
    .drop-shadow
      opacity 1

    .remove-button
      opacity 1

.preview-image
  display block
  width 100%

.dropzone
  transition all .2s linear
  border 2px dashed #ccc
  background-color #fafafa
  min-height initial
  padding 0

  &:before
    display table
    content ''

  &:hover
    border-color primaryBlue
    background-color white

    .dz-message
      .dropzone-title
        color primaryBlue

  .dz-message
    color #666

    span
      line-height 1.8
      font-size 13px
      letter-spacing .4px

      span.dropzone-title
        display block
        color #888
        font-size 1.25em

      span.dropzone-info
        display block
        color #a8a8a8
</style>



// WEBPACK FOOTER //
// src/components/ImageUpload.vue